export default __webpack_public_path__ + "static/media/kupon.bede8185.svg";